module.exports = __webpack_public_path__ + "/dist/assets/images/pdficon.png";